import ContentTypeSDK from '@/docs-partials/sdk/content-types.mdx';
import * as React from 'react';
export default {
  ContentTypeSDK,
  React
};